var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "#5f6368",
  viewBox: "0 -960 960 960"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M400-80 0-480l400-400 71 71-329 329 329 329z"
})));
export default SvgArrowBack;